import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=40795edd&scoped=true"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"
import style0 from "./Agreement.vue?vue&type=style&index=0&id=40795edd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40795edd",
  null
  
)

export default component.exports